import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ContentEntryDataGetter from 'layers/content/Hocs/ContentEntryDataGetter'
import withApiError from 'layers/errorHandling/apiError/component'
import {
  ERROR_TYPE_CONTENTFUL,
  SHOW_CONTENT_ON_401,
} from 'layers/errorHandling/apiError'
import {
  operations as siteOperations,
  selectors as siteSelectors,
  actions as siteActions,
} from 'store/siteManager'
import InformFamilyModalComponent from './component'

const InformFamilyModalContainer = ({
  clearError,
  handleClose,
  hasApiError,
  modals,
  siteId,
  updateSitePreferences,
}) => {
  const closeModal = () => {
    clearError('sitePreferences')
    updateSitePreferences(siteId, {
      k5Digital: {
        familyLetterSent: true,
      },
      mspDigital: {
        familyLetterSent: true,
      },
    })
    handleClose()
  }

  if (!modals) return null

  return (
    <InformFamilyModalComponent
      handleClose={closeModal}
      handleNextButtonClick={closeModal}
      hasApiError={hasApiError}
      modals={modals}
    />
  )
}

InformFamilyModalContainer.propTypes = {
  clearError: PropTypes.func,
  handleClose: PropTypes.func,
  hasApiError: PropTypes.bool,
  modals: PropTypes.array,
  siteId: PropTypes.number,
  updateSitePreferences: PropTypes.func,
}

const mapStateToProps = (state, ownProps) => {
  const site = siteSelectors?.selectSiteById(state, ownProps.siteId)
  const { sitePreferences: sitePreferencesAPIResults } = state.siteManager
  const { error } = sitePreferencesAPIResults

  return {
    hasApiError: !!error,
    site,
  }
}

const mapDispatchToProps = {
  updateSitePreferences: siteOperations.updateSitePreferences,
  clearError: siteActions.clearError,
}

const mapper = entry => {
  const { modals } = entry || {}

  return {
    modals,
  }
}

const options = {
  entryId: '3HVIUWTjfMzvOfh5PpIKEM',
  include: 3,
  mapper,
  spread: true,
}

export default ContentEntryDataGetter(
  withApiError(
    InformFamilyModalContainer,
    [ERROR_TYPE_CONTENTFUL],
    [SHOW_CONTENT_ON_401],
  ),
  options,
  connect(mapStateToProps, mapDispatchToProps),
)
